var _rect, _g, _path, _g2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path2, _rect11, _rect12, _rect13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIconGosiwon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_498_10709",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 22,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.7783,
    width: 21,
    height: 44,
    fill: "#EEEEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_498_10709)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.7783,
    y: 1,
    width: 21,
    height: 43,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7783,
    y: 41,
    width: 21,
    height: 2.93333,
    fill: "#F46940"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7783,
    y: 35,
    width: 21,
    height: 9,
    fill: "#F46940"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_10709)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_498_10709",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4985 1.19377C22.1469 0.935243 21.6694 0.935428 21.318 1.19422L2.77832 14.8478H41.0688L22.4985 1.19377ZM41.0688 14.8486H2.77832V42H41.0688V14.8486Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_498_10709)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7783 1.5C21.4294 1.24615 20.5262 2.94296 20.1774 3.19707L1.77832 16.6036H39.7783L21.7783 1.5ZM39.7783 16.6036H1.77832V43.2645H39.7783V16.6036Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.77832,
    y: 35,
    width: 30.9999,
    height: 8,
    fill: "#F46940"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7783,
    y: 35,
    width: 8,
    height: 6,
    fill: "#614E4E"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 9.77832,
    y: 15,
    width: 10,
    height: 4,
    fill: "#090A0A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 9.77832,
    y: 21,
    width: 10,
    height: 4,
    fill: "#090A0A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 22.7783,
    y: 9,
    width: 9,
    height: 4,
    fill: "#090A0A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 34.7783,
    y: 9,
    width: 4,
    height: 4,
    fill: "#090A0A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 22.7783,
    y: 15,
    width: 9,
    height: 4,
    fill: "#090A0A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 34.7783,
    y: 15,
    width: 4,
    height: 4,
    fill: "#090A0A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 22.7783,
    y: 21,
    width: 9,
    height: 4,
    fill: "#090A0A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 34.7783,
    y: 21,
    width: 4,
    height: 4,
    fill: "#090A0A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 9.77832,
    y: 27,
    width: 10,
    height: 4,
    fill: "#090A0A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7783,
    width: 20,
    height: 4,
    fill: "#F46940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3977 0.826208C25.046 1.72048 24.6726 3.35165 23.7783 4L3.9524 18.1194C3.05813 18.7677 1.80759 18.5683 1.15924 17.6741C0.510896 16.7798 0.710258 15.5293 1.60453 14.8809L21.6045 0.380923C22.4988 -0.267424 23.7493 -0.0680625 24.3977 0.826208Z",
    fill: "#F46940"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.77832,
    y: 41,
    width: 44,
    height: 3,
    fill: "#FB8F6F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7783,
    y: 30,
    width: 6,
    height: 11,
    fill: "#614E4E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7783,
    y: 28,
    width: 6,
    height: 2,
    fill: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_10709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 43,
    fill: "white",
    transform: "translate(2.77832 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconGosiwon);
export default __webpack_public_path__ + "static/media/houseIconGosiwon.e3869f6c651e6503f242fd222d9dd54f.svg";
export { ForwardRef as ReactComponent };